import * as marietta from '../../marietta';
import { JSONParse } from '../LiDAR/jsonParse';
import { CommonInfoData } from '../webcad/util/WebcadJSONExporter';
import { ITEM_MODE_NO, LIDAR_CATEGORY_BATHTUB, UNIT_BATH_DEFAULT_HEIGHT, UNIT_BATH_ITEM_ID } from '../webcad/Constants';

const MM_PER_METER: number = 1000;
// LiDARオブジェクトの dimensions は [幅, 高さ, 奥行] (m)
const DIMENSION_HEIGHT_INDEX: number = 1;

/**
 * LiDAR取込で生成するUBの高さを初期値にする（実測のバスタブ高さでは低すぎるため）
 */
export class LiDARUnitBath {

    /**
     * WebView形式（WebCADのplan）のUBの高さを初期値にする
     */
    public static applyToPlan(plan: { equipment?: CommonInfoData[] }): void {
        plan.equipment?.forEach((item: CommonInfoData) => {
            if (item.id === UNIT_BATH_ITEM_ID) {
                item.height = UNIT_BATH_DEFAULT_HEIGHT;
            }
        });
    }

    /**
     * LiDAR生データのバスタブの高さを初期値にする
     * 親側にも bathtub→UB の対応を持つ（LiDAR/AddFurniture2D の getItemId と合わせること）
     */
    public static applyToRawData(json: JSONParse): void {
        json.plan?.room?.captured?.forEach((captured) => {
            captured?.objects?.forEach((obj) => {
                if (Object.keys(obj.category ?? {})[0] !== LIDAR_CATEGORY_BATHTUB) return;
                obj.dimensions[DIMENSION_HEIGHT_INDEX] = UNIT_BATH_DEFAULT_HEIGHT / MM_PER_METER;
            });
        });
    }

    /**
     * 配置済みのUBの高さを、置いた部屋の天井高さに合わせる
     * 取込後の描き直し（autoCorrection 等）のあとに呼ぶ。描き直しを呼ぶ所が増えると初期値に戻るので、そこでも呼ぶこと
     */
    public static fitToCeiling(): void {
        marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_EQUIPMENT_NO).forEach((item) => {
            marietta.webcad.util.UnitBathUtil.fitToCeiling(item);
        });
    }
}
